<div class="container sms001">
  <!-- ヘッダーエリア -->
  <app-header></app-header>
  <!-- メインエリア -->
  <div class="main-area">
  </div>

</div>
